import React from "react";
import _get from "lodash/get";
import { Link } from "react-router-dom";
import { Button, Card, Tag, Input, Icon, message, Modal, DatePicker, Spin } from "antd";
import { connect } from "react-redux";
import axios from "services/axios";
import moment from "moment";

import downloadCsv from "../../../../services/downloadCsv";
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';

const { RangePicker } = DatePicker;

const mapForDownloadCsv = data => {
  let dataTable = data.map(d => ({
    "Tgl Appraisal": moment(_get(d, "Booking.bookingTime")).format("YYYY-MM-DD"),
    Appraiser: _get(d, "Booking.Appraiser.name"),
    Mobil: `${_get(d, "Booking.Appraisal.carDetail[3].value")} ${_get(d, "Booking.Appraisal.carDetail[4].value")} ${_get(d, "Booking.Appraisal.carDetail[5].value")}`,
    "Plat No": _get(d, "Booking.Appraisal.carDetail[7].value"),
    Tahun: _get(d, "Booking.Appraisal.carDetail[6].value"),
    KM: _get(d, "Booking.Appraisal.carDetail[11].value"),
    PIC: _get(d, "PriceNegotiator.name"),
  }));
  downloadCsv(dataTable, "inquiry_report.csv");
};

class Handover extends React.Component {
  state = {
    searchText: "",
    dataSource: [],
    rangeTime: [],
    isDataReady: false,
    visibleConfirmModal: false,
    count: 1,
    page: 0,
    rowPerPage: 15
  };

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text => text,
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  getMuiTheme = () => createMuiTheme({
    typography: {
      useNextVariants: true,
    },
    overrides: {
      MUIDataTableBodyCell: {
        root: {
          "white-space": "nowrap",
          '&:nth-child(1)': {
            "width": "8em",
            "min-width": "8em",
            "max-width": "8em",
            "word-break": "break-all"
          }
        }
      }
    }
  });

  displayStatusTag(status) {
    switch (status) {
      case "WAITING_HANDOVER":
        return <Tag color="green">{status}</Tag>;
      case "WAITING_ASSIGNMENT_HANDOVER":
        return <Tag color="magenta">{status}</Tag>;
      default:
        return <Tag color="orange">{status}</Tag>;
    }
  }

  fetchData = async (page = 1, paginate = 15) => {
    try {
      let {data} = await axios.get(`/car-inquiry/pagination?status[]=WAITING_HANDOVER&status[]=WAITING_ASSIGNMENT_HANDOVER&page=${page}&limit=${paginate}`);
      this.setState({
        dataSource: data.inquiries,
        isDataReady: true,
        count: data.total,
        page: page,
        rowPerPage: paginate
      });
    } catch (err) {
      console.log(err);
      message.error("Error, Can't fetch Inquiries");
    }
  }

  changePage(page, paginate) {
    this.setState({ isDataReady: false }, () =>
      this.fetchData(page, paginate)
    );
  }
  
  componentDidMount = async () => {
    this.fetchData()
    // try {
    //   let {data} = await axios.get("/car-inquiry");
    //   let inquiries= await data.inquiries.filter( inquiry => inquiry.status === "WAITING_HANDOVER" || inquiry.status === "WAITING_ASSIGNMENT_HANDOVER")
    //   this.setState({
    //     dataSource: inquiries,
    //     isDataReady: true,
    //   });
    // } catch (err) {
    //   console.log(err);
    //   message.error("Error, Can't fetch Inquiries");
    // }
  };

  visibleModalConfirmation() {
    this.setState({
      visibleConfirmModal: !this.state.visibleConfirmModal
    })
  }

  async confirmationDownload() {
      const { dataSource, rangeTime } = this.state;
      let inquiries = dataSource;
      if( rangeTime.length > 0 ) {
        inquiries = await dataSource.filter(item => new Date(item.Booking.bookingTime).getTime() >= new Date(rangeTime[0]).getTime() && new Date(item.Booking.bookingTime).getTime() <= new Date(rangeTime[1]).getTime())
      }
      if(inquiries.length === 0) {
        message.error('Data Car Inquiry Kosong')
      } else {
        mapForDownloadCsv(inquiries)
        this.visibleModalConfirmation()
      }
  }

  onChangeRange(date, dateString) {
    this.setState({
      rangeTime: dateString
    })
  }

  render() {
    const columns = [
      "Action",
      "Status",
      "Booking ID",
      "PIC",
      "Plat Nomor",
      "Mobil",
      {
        name: "Hari/Tgl Appraisal",
        options: {
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <div>{moment(value).format("YYYY-MM-DD hh:mm A")}</div>
            );
          }
        }
      },
      "Appraiser",
    ];

    const options = {
      filter: false,
      responsive: 'simple',
      fixedHeader: true,
      tableBodyHeight: '400px',
      print: false,
      selectableRows: 'none',
      rowsPerPage: this.state.rowPerPage,
      serverSide: true,
      count: this.state.count,
      page: this.state.page,
      onTableChange: (action, tableState) => {
        console.log(action);
        switch (action) {
          case "changePage":
            let page = tableState.page++;
            this.changePage(page, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.changePage(tableState.page, tableState.rowsPerPage);
            break;
          case "search":
            this.changePage(
              tableState.page,
              tableState.rowsPerPage
            );
            break;
          default:
            console.log(action);
        }
      },
    };

    const data = this.state.dataSource.map(item => {
      return [
        <Link to={`/home/internal-bidding/handover/${item.id}/`}>
            <Button size="small" type="primary">
              Update
            </Button>
          </Link>,
        this.displayStatusTag(item.status),
        item.bookingId,
        item.Booking.SalesProfile.BOH || "",
        item.Booking.Appraisal.carDetail[7].value,
        `${item.Booking.Appraisal.carDetail[3].value} ${item.Booking.Appraisal.carDetail[4].value} ${item.Booking.Appraisal.carDetail[5].value}`,
        item.Booking.bookingTime,
        item.Booking.Appraiser.name,
      ]
    });

    return (
      <Card style={{ marginTop: "30px" }}>
        <Button onClick={() => this.visibleModalConfirmation()}>Download Report</Button>

        <Spin size="large" spinning={!this.state.isDataReady} tip="Loading...">
          <MuiThemeProvider theme={this.getMuiTheme()}>
            <MUIDataTable
              title={"PRICE OFFERING"}
              data={data}
              columns={columns}
              options={options}
            />
          </MuiThemeProvider>
        </Spin>

        <Modal
          visible={this.state.visibleConfirmModal}
          title="Download Data Inquiry"
          onOk={() => this.confirmationDownload()}
          onCancel={() => this.visibleModalConfirmation()}
          confirmLoading={this.state.confirmLoading}
        >
          <p>Pilih range waktu</p>
          <RangePicker format="YYYY-MM-DD HH:mm:ss" onChange={(date, dateString) => this.onChangeRange(date, dateString)}/>
        </Modal>
      </Card>
    );
  }
}

const mapStateToProps = ({ Auth }) => ({ Auth });

export default connect(mapStateToProps)(Handover);



// WEBPACK FOOTER //
// src/components/Dashboard/InternalBidding/Handover/Handover.js